import React from 'react'
import Default from './Default'

const lessonTypes = {
  cols: Default,
  rows: Default,
}

export const FooterType = props => {
  const Type = lessonTypes[props.type || 'rows']
  if(!Type) return null

  return <Type {...props} />
}
